import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {useAbortController, useAppSelector} from "../../../../hooks";
import {selectToken} from "../../../../features/account/accountSlice";
import React, {Fragment, useEffect, useState} from "react";
import {getBillingStatistic} from "../../../../api/ApiHelper";
import {logError} from "../../../../helpers/LogHelper";
import {Breadcrumbs} from "../../../Widgets/Breadcrumbs/Breadcrumbs";
import Loader from "../../../Widgets/Loader/Loader";
import {FetchError} from "../../../Widgets/FetchError/FetchError";
import {USERS_ROUTE} from "../../../../routes";
import {BillingStatistic} from "../../../../models/BillingStatistic";
import {formatGigaBytes} from "../../../../helpers/FormatHelper";
import {DATA_LIST_PAGE_SIZE} from "../../../../settings";
import {BillingUsersList} from "../../../Widgets/BillingUsersList/BillingUsersList";
import {ListItemContextMenu, openInNewTab, useListContextMenu} from "../../../Widgets/ListItemContextMenu/ListItemContextMenu";

function BillingView() {
    const {t} = useTranslation();
    const history = useNavigate();
    const {menuProps, anchorPoint, targetId, onContextMenu, close} = useListContextMenu();
    const token = useAppSelector(selectToken);
    const [controller] = useAbortController();
    const [isFetching, setFetchingState] = useState(true);
    const [hasError, setErrorState] = useState(false);
    const [statistic, setStatistic] = useState(undefined as BillingStatistic | undefined);
    const fetchData = () => {
        if (token) {
            setFetchingState(true);
            getBillingStatistic(token.token, controller, data => {
                setStatistic(data);
                setErrorState(false);
                setFetchingState(false);
            }, error => {
                logError("Demo data info fetch error", error);
                setFetchingState(false);
                setErrorState(true);
            });
        }
    };
    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const userPath = (id: string) => `${USERS_ROUTE}/${id}`;
    const userClickHandler = (id: string) => {
        history(userPath(id));
    };
    const openClickHandler = () => {
        if (targetId) {
            userClickHandler(targetId);
        }
    };
    const openInNewTabClickHandler = () => {
        if (targetId) {
            openInNewTab(userPath(targetId));
        }
    };
    return (<div>
        <Breadcrumbs/>
        {isFetching && <Loader/>}
        {!isFetching && hasError &&
            <FetchError onRetry={() => fetchData()}/>
        }
        {!isFetching && !hasError && statistic &&
            <Fragment>
                <div className="d-flex justify-content-center my-4">
                    <div className="details-table">
                        <table>
                            <thead>
                            <tr className="table-header">
                                <th>{t("total_files")}</th>
                                <td>{statistic.totalRecords}</td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <th>{t("total_size")}</th>
                                <td>{formatGigaBytes(statistic.totalSize)} {t("file_size_units_gb")}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="my-4">
                    <BillingUsersList tag="billing_users" pageSize={DATA_LIST_PAGE_SIZE}
                                      userClickHandler={userClickHandler} contextMenuHandler={onContextMenu}/>
                </div>
                <ListItemContextMenu menuProps={menuProps} anchorPoint={anchorPoint}
                                     onClose={close} onOpen={openClickHandler} onOpenInNewTab={openInNewTabClickHandler}/>
            </Fragment>
        }
    </div>);
}

export default BillingView;
